// OnboardingModel符号标识
export const OnboardingModel = Symbol.for('OnboardingModel');
